// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__41cQo","icon":"Checkbox_icon__2goiU","focus":"Checkbox_focus__2aglz"};